import { render, staticRenderFns } from "./SocialVisitDetails.vue?vue&type=template&id=8c90b4ce&scoped=true&"
import script from "./SocialVisitDetails.vue?vue&type=script&lang=js&"
export * from "./SocialVisitDetails.vue?vue&type=script&lang=js&"
import style0 from "./SocialVisitDetails.vue?vue&type=style&index=0&id=8c90b4ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c90b4ce",
  null
  
)

export default component.exports